import { Injectable, Signal } from '@angular/core';
import { IMaritalData, IMaritalModel } from '@partners/api';
import { Observable } from 'rxjs';
import { StateAccessService } from '../../../services';
import { IMaritalState, MaritalActions, MaritalSelectors } from '../store';

@Injectable({
  providedIn: 'root'
})
export class MaritalStore extends StateAccessService<IMaritalState> {
  readonly state$: Observable<IMaritalState>;

  readonly data$$: Signal<IMaritalData>;
  readonly model$$: Signal<IMaritalModel>;

  constructor() {
    super();

    this.model$$ = this.stateFacade.selectSignal$(MaritalSelectors.model);
    this.data$$ = this.stateFacade.selectSignal$(MaritalSelectors.data);
  }

  dispatchMaritalReset() {
    this.stateFacade.dispatch(MaritalActions.reset());
  }
  dispatchMaritalLoad() {
    this.stateFacade.dispatch(MaritalActions.load());
  }
  dispatchMaritalLoadSuccess({ model, data }: { model: IMaritalModel; data: IMaritalData }) {
    this.stateFacade.dispatch(MaritalActions.loadSuccess({ model, data }));
  }
  dispatchMaritalSubmit() {
    this.stateFacade.dispatch(MaritalActions.submit());
  }
  dispatchMaritalSubmitSuccess({ model, data }: { model: IMaritalModel; data: IMaritalData }) {
    this.stateFacade.dispatch(MaritalActions.submitSuccess({ model, data }));
  }
}
